import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PAYMENT_CONFIRMATION_ANALYTICS_ACTIONS } from './payment-confirmation-analytics.actions';
import { PaymentConfirmationPageLoad } from './payment-confirmation-analytics.transformers';
import { PaymentConfirmationAnalyticsMessages } from './payment-confirmation-analytics.constants';
import { Tracking } from '@panamax/app-state';

export enum PaymentStatus {
  success = 'success',
  partSuccess = 'partial success',
  failed = 'failed',
}
export interface AnalyticsEventData {
  customerCount: number;
  fileCount: number;
  paymentStatus: PaymentStatus;
  totalAmount: number;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentConfirmationAnalyticsService {
  constructor(private store: Store) {}

  trackPageLoad(eventData: AnalyticsEventData) {
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: PaymentConfirmationAnalyticsMessages.capability,
          event: PaymentConfirmationAnalyticsMessages.pageLoadedEvent,
          pageName: PaymentConfirmationAnalyticsMessages.pageName,
          ...eventData,
        },
        transformFunc: PaymentConfirmationPageLoad,
      },
    };
    this.store.dispatch(
      PAYMENT_CONFIRMATION_ANALYTICS_ACTIONS.trackPageLoad({ tracking }),
    );
  }
}
